import ApiService from '@/services/api.service'


const IncidentReportService = {
    

    getAll(parameter, addExtraParams = false) {
      const params = {
         // commun params for  listing
        SearchCriteria: parameter.SearchCriteria,
        PageSize: parameter.PageSize,          
        PageNumber : parameter.PageNumber,
        DateFrom : parameter.DateFrom,
        DateTo : parameter.DateTo,
      };

      if (addExtraParams) {
        // Add extra params , only for report listing
        params.PatientCodeList = parameter.PatientCodeList;
        params.PrimaryCategoryCodeList = parameter.PrimaryCategoryCodeList;
        params.ReporterCodeList = parameter.ReporterCodeList;
        params.SeverityCodeList = parameter.SeverityCodeList;
        params.StatusList = parameter.StatusList;
        params.RoomCodeList = parameter.RoomCodeList;

        return ApiService.getWithArray('/IncidentReport',params); 
      } else {
         // Add extra params , only for listing
        params.CategoryCode = parameter.Incident;
        params.ReporterCode = parameter.Reporter;
        params.SeverityCode = parameter.Severity;
        params.RoomCode = parameter.Building;
        params.Status = parameter.Status;
      }

      const requestData = {
        method: 'get',
        url: "/IncidentReport/",
        headers: {},
        params: params
      };
      return ApiService.customRequest(requestData);
         
      
    },

    Get(IncidentID) {
      return ApiService.get(`/IncidentReport/${IncidentID}`);
    },
    
    CanSeeIncidentAdmin() {
      return ApiService.get(`/IncidentReport/CanSeeIncidentAdmin/`);
    },

    IncidentStatus(Id) {
      return ApiService.get(`/IncidentReport/IncidentStatus?IncidentId=${Id}`);
    },

    AddIncident(data){
      return ApiService.post(`/IncidentReport`, data);
    },

    UpdateIncident(Id,data){        
      return ApiService.put(`/IncidentReport/${Id}`,data);
    }, 

    SetVoid(IncidentID) {
      return ApiService.put(`/IncidentReport/Void/${IncidentID}`);
    },

    getLocation(){
      return ApiService.get(`/ProviderCodes?TableName=LOCATION`); 
    },

    getParticipationTypeClients(){
      return ApiService.get(`/ProviderCodes?TableName=PPARTICIPATION`); 
    },

    getParticipationTypeEmployees(){
      return ApiService.get(`/ProviderCodes?TableName=EPARTICIPATION`); 
    },

    getParticipationTypeContacts(){
      return ApiService.get(`/ProviderCodes?TableName=CPARTICIPATION`); 
    },

    getParticipationTypeVisitors(){
      return ApiService.get(`/ProviderCodes?TableName=VPARTICIPATION`); 
    },

    createIncidentId(){
      return ApiService.get(`/Utils/GetTimedKey`);
    },

    completeDraft(IncidentID,Reporter){
      return ApiService.get(`/IncidentReport/CompleteDraft/${IncidentID}:${Reporter}`);
    },

    setBackToDraft(IncidentID){
      return ApiService.get(`/IncidentReport/SetBackToDraft/${IncidentID}`);
    },

    IncidentReportHeader(IncidentID){
      return ApiService.get(`/IncidentReport/ListingReportHeader?IncidentID=${IncidentID}`);
    },

    getIncidentsReportList(parameter){
        const params = {
          PageNumber         : parameter.PageNumber,
          PageSize           : parameter.PageSize,
          startDate          : parameter.startDate,
          endDate            : parameter.endDate,
          employee           : parameter.employee,
          program            : parameter.program,
          apptType           : parameter.apptType,
          reason             : parameter.reason,
          patient            : parameter.patient,
          showedup           : parameter.showedup,
          confirmed          : parameter.confirmed,
          order              : parameter.order,
          searchCriteria     : parameter.SearchCriteria,
        }
        return ApiService.getWithArray('/IncidentReport/ListingReport',params); 
      },
  }
  
  export default IncidentReportService;